<div
  *ngIf="!removeContentWhileLoading || !isLoading"
  [style.display]="isLoading ? 'none': ''">
    <ng-content></ng-content>
</div>
<div *ngIf="isLoading"
  [style.height]="height"
  [style.width]="width"
  [style.background]="background"
  [style.position]="'absolute'"
  [style.top]="0"
  [style.left]="0">
  <div [style.height]="marginTop"></div>
  <div class="k-i-loading"
    [style.font-size]="size"
    [style.color]="color">
  </div>
</div>
